module.exports = __webpack_public_path__ + "img/article-image-1.14be5c28.jpeg";